import { render, staticRenderFns } from "./ReleaseTabView.vue?vue&type=template&id=0987cf26&"
import script from "./ReleaseTabView.vue?vue&type=script&lang=js&"
export * from "./ReleaseTabView.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseTabView.vue?vue&type=style&index=0&id=0987cf26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports